// (Админы elementary_timetable/grid.js-ийн хуулбар — хамт засна)
// Бага ангийн хуваарийн хүснэгт — мөрүүд (цагийн интервал) × гараг (1–5).
// Урт мөр (ж. Пү 11:25–12:30) доорх хэд хэдэн мөрийг босоо хамарна (rowSpan);
// 5 гарагт ижил нэр/төрөлтэй мөр нэг нүд болно (full) — xlsx-ийн нэгтгэсэн нүд шиг.
export const DAYS = [1, 2, 3, 4, 5];
export const DAY_MN = ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан"];
export const KIND_LABEL = { lesson: "Хичээл", project: "Төсөл", routine: "Үйл ажиллагаа", meal: "Цай, хоол", break: "Завсарлага", daycare: "Өдөр өнжүүлэх" };
export const KIND_STYLE = {
  lesson: "bg-violet-50 text-violet-900 border-violet-200",
  project: "bg-amber-50 text-amber-900 border-amber-200",
  routine: "bg-sky-50 text-sky-900 border-sky-200",
  meal: "bg-emerald-50 text-emerald-900 border-emerald-200",
  break: "bg-gray-50 text-gray-500 border-gray-200",
  daycare: "bg-rose-50 text-rose-900 border-rose-200",
};

const key = (s) => `${s.startTime}-${s.endTime}`;
const inside = (a, b) => a.startTime >= b.startTime && a.endTime <= b.endTime; // a нь b дотор

export function buildGrid(slots) {
  const pairs = [...new Map(slots.map((s) => [key(s), { startTime: s.startTime, endTime: s.endTime }])).values()];
  // Өөр 2+ мөрийг агуулсан интервал мөр болохгүй — тэр нүд тэдгээрийг хамарна
  let rows = pairs.filter((p) => pairs.filter((q) => q !== p && inside(q, p)).length < 2);
  rows.sort((a, b) => a.startTime.localeCompare(b.startTime) || a.endTime.localeCompare(b.endTime));
  rows = rows.map((r) => ({ ...r, cells: {}, full: null }));
  DAYS.forEach((d) => {
    slots.filter((s) => s.day === d).forEach((s) => {
      // Өөрийн интервалтай мөр байвал тэнд (ж. Өдөр өнжүүлэх 15:30–18:30), үгүй бол дотор нь орох мөрүүдийг хамарна
      const own = rows.findIndex((r) => key(r) === key(s));
      const idx = own >= 0 ? [own] : rows.map((r, i) => (inside(r, s) ? i : -1)).filter((i) => i >= 0);
      const first = idx.length ? idx[0] : rows.findIndex((r) => r.startTime === s.startTime);
      if (first < 0) return;
      const cell = rows[first].cells[d];
      if (cell?.slots) { cell.slots.push(s); return; } // нэг цагт хоёр мөр — хамт харуулна
      rows[first].cells[d] = { slots: [s], rowSpan: Math.max(1, idx.length) };
      idx.slice(1).forEach((i) => { rows[i].cells[d] = { covered: true }; });
    });
  });
  rows.forEach((r) => {
    const cs = DAYS.map((d) => r.cells[d]);
    const one = cs.every((c) => c?.slots?.length === 1 && c.rowSpan === 1);
    if (one && cs.every((c) => c.slots[0].title === cs[0].slots[0].title && c.slots[0].kind === cs[0].slots[0].kind)) r.full = cs.map((c) => c.slots[0]);
  });
  return rows;
}
